module.exports = __webpack_public_path__ + "static/media/icon-racket.af7c70b7.svg";